import { sync } from 'vuex-router-sync'

export default ({ router, store, Vue }) => {
  sync(store, router)
}
